import { render, staticRenderFns } from "./myDeclaration.vue?vue&type=template&id=3a04f9dc&scoped=true&"
import script from "./myDeclaration.vue?vue&type=script&lang=js&"
export * from "./myDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./myDeclaration.vue?vue&type=style&index=0&id=3a04f9dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a04f9dc",
  null
  
)

export default component.exports